import type { OrderLine, Orders } from '../../../Tab.types'

export function canOrderLineBeConfirmed(orderLine: OrderLine) {
  return ['NEW', 'PAID'].includes(orderLine.state.code)
}

export function getData(orders: Orders) {
  const orderLineIdsToValidate: number[] = []
  const ordersThatCanNotBeConfirmed: Orders = []

  orders.forEach((order) => {
    let canBeConfirmed = false

    order.orderLines.forEach((orderLine) => {
      if (canOrderLineBeConfirmed(orderLine)) {
        orderLineIdsToValidate.push(orderLine.id)
        canBeConfirmed = true
      }
    })

    if (!canBeConfirmed) {
      ordersThatCanNotBeConfirmed.push(order)
    }
  })

  return { orderLineIdsToValidate, ordersThatCanNotBeConfirmed }
}
